import { getLastInvoices } from '@services/requests/billing';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const ThunkGetLastInvoices = createAsyncThunk(
  'billing/getLastInvoices',
  () => getLastInvoices(),
);

export default {};
